import React, { useEffect, useRef, useState } from 'react'
import Compressor from 'compressorjs'

import { IMAGE_COMPRESS_SIZE } from '@/constants/length'
import { Colors } from '@/constants/styles/color'
import HeadeLine from '@/components/atoms/HeadLine'
import TrimmingHeaderImageContainer from '@/components/molecules/TrimmingHeaderImage'

import ImageEdit from '@/assets/img/icons/ImageEdit.svg'
import { useThemeContext } from '@/contexts/ThemeContext'
import styles from '../style.module.scss'

interface Props {
  image: string
}

const CreatorHeaderImage = ({ image }: Props) => {
  // ヘッダー画像
  const { themeColors } = useThemeContext()
  const headerImagePickerRef = useRef<HTMLInputElement>(null)
  const [currentHeaderImg, setCurrentHeaderImg] = useState<any>(null)
  const [headerImage, setHeaderImage] = useState('')
  const [headerImgCanvas, setHeaderImgCanvas] = useState<HTMLCanvasElement>()

  useEffect(() => {
    setHeaderImage(image)
    setCurrentHeaderImg(image)
  }, [image])

  useEffect(() => {
    if (headerImgCanvas) {
      setHeaderImage(headerImgCanvas.toDataURL())
      setCurrentHeaderImg(headerImgCanvas.toDataURL())
    }
  }, [headerImgCanvas])

  // ヘッダー画像のトリミング
  const [trimHeaderImageModal, setTrimHeaderImageModal] = useState<boolean>(false)
  // モーダルの隠蔽
  const [, setHide] = useState<boolean>(false)

  const uploadHeaderImage = async (e: React.ChangeEvent<HTMLInputElement>) => {
    setHide(true)
    // ファイル読み込み
    const reader = new FileReader()

    if (e.currentTarget.files !== null) {
      const file = e.currentTarget.files[0]
      if (file.size > IMAGE_COMPRESS_SIZE) {
        new Compressor(file, {
          quality: 0.4,
          success(result) {
            reader.readAsDataURL(result)
          },
          error(err) {
            console.log(err.message)
          },
        })
      } else {
        await reader.readAsDataURL(file)
      }
    }

    reader.onload = (readerEvent: ProgressEvent) => {
      setHeaderImage((readerEvent.target as FileReader).result as string)
      setTrimHeaderImageModal(true)
    }
    setHide(false)
  }

  const cancel = () => {
    const inputCoverImageElem = document.getElementById('headerImage') as HTMLInputElement
    if (inputCoverImageElem) inputCoverImageElem.value = ''
    setHeaderImage(currentHeaderImg)
    setTrimHeaderImageModal(false)
  }

  return (
    <div className={styles.profileBlock}>
      <div className={styles.profileBlockItem}>
        <div className={styles.blockTitleField}>
          <HeadeLine text="ヘッダー画像" textColor={themeColors.text} />
        </div>
        <div className={styles.headerImage}>
          <div className={styles.cardBase} onClick={() => headerImagePickerRef?.current?.click()}>
            {/* ヘッダー画像 */}
            <div
              className={styles.headerCard}
              style={{
                backgroundImage: headerImage ? `url(${headerImage})` : ``,
                backgroundColor: !headerImage ? Colors.BK_GRAY : '',
                backgroundSize: 'cover',
              }}
            >
              {!headerImage ? (
                <div className={styles.ImageEditLarge}>
                  <ImageEdit
                    style={{
                      width: '35px',
                      height: '35px',
                    }}
                  />
                </div>
              ) : (
                <div className={styles.ImageEditLargeBK}>
                  <ImageEdit
                    style={{
                      width: '35px',
                      height: '35px',
                      filter: 'drop-shadow(0px 0px 5px rgba(0, 0, 0, 0.1))',
                      fill: Colors.WHITE,
                    }}
                  />
                </div>
              )}
              <div>
                <input
                  id="headerImage"
                  ref={headerImagePickerRef}
                  onChange={uploadHeaderImage}
                  type="file"
                  hidden
                  accept=".png, .jpeg, .jpg"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      {trimHeaderImageModal && (
        <TrimmingHeaderImageContainer
          img={headerImage}
          aspectRatio={360 / 152}
          setTrimModal={setTrimHeaderImageModal}
          setSelectedHeaderImage={setHeaderImgCanvas}
          cancel={cancel}
        />
      )}
    </div>
  )
}

export default CreatorHeaderImage
